import { Content, Row, Col, Button, H1, H2 } from 'components/common'
import { React, Image, styled, mq } from 'x'
import { Link } from 'gatsby'
import Arrow from 'static/svg/arrow.svg'

const Container = styled.div`
  display: block;
  padding: 40px 0;
  margin-left: auto;
  margin-right: auto;
`

const SectionContent = styled(Content)`
  margin-left: auto;
  margin-right: auto;
  padding: 0 30px;
  max-width: 90%;
  @media (min-width: 2000px) {
    max-width: 1366px;
  }
`

const Title = styled(H1)`
  max-width: 100%;
  color: #fff;
  text-align: center;
  width: 100%;
  margin-bottom: 20px;
  font-size: 42px;
  font-weight: 800;
`

const Subtitle = styled.h2`
  max-width: 100%;
  color: #fff;
  text-align: center;
  width: 100%;
  margin-top: 0;
  margin-bottom: 30px;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 600;
`

const Inner = styled.div`
  ${mq.above('lg')} {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
    margin-right: -30px;
    margin-left: -30px;
    justify-content: center;
  }

  margin-top: 30px;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

const Item = styled.div`
  ${mq.above('sm')} {
    flex-direction: row;
  }

  ${mq.above('lg')} {
    flex: 1 1 33.3336%;
    max-width: 33.3336%;
    padding: 0 30px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  max-width: 100%;
  margin-bottom: 30px;
  align-items: center;
`

const ItemImgWrapper = styled.div`
  ${mq.above('sm')} {
    flex: 0 0 80px;
    padding: 0 15px;
    margin-bottom: 0;
  }

  ${mq.above('lg')} {
    flex: 0 1 80px;
    padding: 0;
    margin-bottom: 30px;
  }

  margin-bottom: 0;

  ${mq.below('sm')} {
    margin-bottom: 30px;
    flex: 1 1 80px;
  }
`

const ItemContent = styled.div`
  ${mq.above('sm')} {
    flex: 1 1 auto;
    text-align: left;
    padding: 0 15px;
  }

  ${mq.above('lg')} {
    flex: 0 1 auto;
    text-align: center;
    padding: 0;
  }

  padding: 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1 100%;
  text-align: center;
`

const ItemTitle = styled.h2`
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 0;
`

const ItemSubtitle = styled.p`
  font-size: 18px;
  line-height: 1.2;
  color: #fff;
  margin: 30px 0;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 30px;
`

const AnimatedButton = styled(Button)`
  margin: 0 auto;
  height: 46px;
  line-height: 46px;
  min-width: 200px;
  font-size: 20px;
  font-weight: 800;
  text-transform: capitalize;
  color: #3e4d72;
  & svg {
    transition: transform 0.3s;
    &.circle {
      background-color: #3e4d72;
      fill: #ffffff;
      opacity: 0.7;
    }
  }
  &:hover {
    color: #3e4d72;
    & svg {
      transform: translateX(10px);
      &.circle {
        opacity: 1;
      }
    }
  }
  ${mq.below('sm')} {
    min-width: auto;
  }
`

const Section = (props) => {
  const items = props.data.items
    ? props.data.items
    : [
        {
          bgColour: props.data.items?.bgColour,
          image: props.data.items?.image.imgixImageWp.fluid,
          imageLocal: props.data.items?.image.source_url,
          title: props.data.items?.title,
          subtitle: props.data.items?.subtitle,
          link: props.data.items?.link,
        },
      ]

  return (
    <Container style={{ backgroundColor: props.data.bgColour || 'black' }}>
      <SectionContent>
        <Row>
          <Col>
            {props.data.title && (
              <Title style={{color: props.data.bgColour !== '#ffffff' ? '#fff' : '#292d58'}}>
                {props.data.title}
              </Title>
            )}
            {props.data.subtitle && (
              <Subtitle>
                {props.data.subtitle}
              </Subtitle>
            )}
          </Col>
        </Row>
        {props.data.items.length > 0 && (
          <Inner index={props.index}>
            {items.map((item, index) => (
              <Item key={'item-' + index}>
                {item.link ? (
                  <Link to={item.link}>
                    <ItemImgWrapper>
                      {item?.image?.imgixImageWp?.fixed && (
                        <Image fixed={{ ...item.image.imgixImageWp.fixed }} />
                      )}
                    </ItemImgWrapper>
                  </Link>
                ) : (
                  <ItemImgWrapper>
                    {item?.image?.imgixImageWp?.fixed && (
                      <Image fixed={{ ...item.image.imgixImageWp.fixed }} />
                    )}
                  </ItemImgWrapper>
                )}
                <ItemContent>
                  {item.title && (
                    <ItemTitle
                      style={{
                        color:
                          props.data.bgColour !== '#ffffff'
                            ? '#fff'
                            : '#292d58',
                      }}
                    >
                      {item.title}
                    </ItemTitle>
                  )}
                  {item.subtitle && (
                    <ItemSubtitle
                      style={{
                        color:
                          props.data.bgColour !== '#ffffff'
                            ? '#fff'
                            : '#292d58',
                      }}
                    >
                      {item.subtitle}
                    </ItemSubtitle>
                  )}
                </ItemContent>
              </Item>
            ))}
          </Inner>
        )}
        {props.data.ctaLabel && (
          <Row>
            <Col style={{ textAlign: 'center' }}>
              <AnimatedButton to={props.data.ctaURL}>
                <span>{props.data.ctaLabel}</span>
                <Arrow className="circle" />
              </AnimatedButton>
            </Col>
          </Row>
        )}
      </SectionContent>
    </Container>
  )
}
export default Section
